module.exports = __webpack_public_path__ + "static/media/baratheon_token.b0a42527.png";